import { FormattedMessage } from "react-intl"

const Content02 = () => {
    const data = {
        number: "02.",
        items: [
            {
                titleKey: "LANDINGPAGE.BENEFITS_2_FEATURE1_TITLE",
                descriptionKey: "LANDINGPAGE.BENEFITS_2_FEATURE1_DESC",
            },
            {
                titleKey: "LANDINGPAGE.BENEFITS_2_FEATURE2_TITLE",
                descriptionKey: "LANDINGPAGE.BENEFITS_2_FEATURE2_DESC",
            },
            {
                titleKey: "LANDINGPAGE.BENEFITS_2_FEATURE3_TITLE",
                descriptionKey: "LANDINGPAGE.BENEFITS_2_FEATURE3_DESC",
            },
        ]
    }

    return (
        <div className="col-span-5 px-4 pt-10 text-[#FFFFFF] md:px-10 lg:col-span-3 lg:pl-28 lg:pr-10 lg:pt-20 xl:pl-40 xl:pr-32">
            <div className="text-6xl font-semibold bg-gradient-to-b from-white to-[#5AE65E] bg-clip-text text-transparent">{data.number}</div>
            <div className="mt-4 text-4xl font-bold">
                <FormattedMessage id="LANDINGPAGE.BENEFITS_2_TITLE"/>
            </div>
            <div className="flex items-center justify-start py-4">
                <div className="flex items-center">
                    <div className="h-[1px] w-20 bg-[#5AE65E]"></div>
                    <div className="w-1 h-1 bg-[#5AE65E]" style={{ clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' }}></div>
                </div>
            </div>
            <div className="mb-8 text-base font-normal text-[#BEBEBE]">
                <FormattedMessage id="LANDINGPAGE.BENEFITS_2_SUBTITLE"/>
            </div>
            <div className="mb-4 text-base gap-5 lg:text-sm xl:pr-16 2xl:text-sm">
                {data.items.map((item, index) => (
                    <div key={index} className="flex items-start mb-6 gap-2">
                        <img src="/media/images/icon/checked.png" alt="checked" className="w-5 h-5"/>
                        <div>
                            <div className="font-medium">
                                <span className="font-bold">
                                    <FormattedMessage id={item.titleKey}/>
                                </span>: <FormattedMessage id={item.descriptionKey}/>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Content02;